import _keyBy from "lodash/keyBy";
import _flatMap from "lodash/flatMap";
import _flow from "lodash/flow";
import _map from "lodash/map";
import _filter from "lodash/filter";
import _groupBy from "lodash/groupBy";
import _sortBy from "lodash/sortBy";
import _orderBy from "lodash/orderBy";
import _find from "lodash/find";
import _maxBy from "lodash/maxBy";
import Skill from "models/Skill";
import { IGetFacetsResponse } from "shared-services";

// Facet level logic is - top-rated facet (with star icon) always will have a higher position number.
// If the current skill level is equal to top-rated, then the star icon appears

export function mapFacetsToSkills(
  facetListData: IGetFacetsResponse,
  skillList: Skill[]
) {
  const categoryLookup = _keyBy(facetListData, "id");
  const flatMapFacets = _flatMap(facetListData, (cat) =>
    _flatMap(cat.facetGroups, "facets")
  );
  const facetLookup = _keyBy(flatMapFacets, "id");

  const transformPipeline = _flow([
    (list) =>
      _map(list, (skill) => {
        const category = categoryLookup[skill.facetCategoryId];
        const topRatedFacetLevel = _maxBy(category?.facetLevels, "position");
        const facetLevel = _find(category?.facetLevels, ["id", skill.levelId]);

        return {
          categoryName: category?.name,
          facetName: facetLookup[skill.facetId]?.name,
          isHighlighted:
            Number(facetLevel?.position) ===
            Number(topRatedFacetLevel?.position),
          levelName: facetLevel?.name,
        };
      }),
    (list) => _filter(list, (item) => !!item.categoryName && !!item.facetName),
    (list) => _groupBy(list, "categoryName"),
    (grouped) =>
      _map(grouped, (items, categoryName) => [
        categoryName,
        _map(
          _orderBy(
            items,
            [(item) => item.isHighlighted, (item) => item.facetName],
            ["desc", "asc"]
          ),
          (item) => [item.facetName, item.isHighlighted, item.levelName]
        ),
      ]),
    (finalList) => _sortBy(finalList, (pair) => pair[0]),
  ]);

  return transformPipeline(skillList);
}
